import React from 'react';
import Icon from '@/components/ui/AppIcon';
import AppLogo from '@/components/ui/AppLogo';

const benefits = [
  {
    id: 'benefit-001',
    icon: 'HeartIcon',
    title: 'Save Your Wishlist',
    description: 'Bookmark flights and hotels across devices. Your wishlist syncs everywhere.',
  },
  {
    id: 'benefit-002',
    icon: 'BellAlertIcon',
    title: 'Price Drop Alerts',
    description: 'Set a target price. We notify you the moment a route drops to your budget.',
  },
  {
    id: 'benefit-003',
    icon: 'MagnifyingGlassIcon',
    title: 'Saved Searches',
    description: 'Re-run any past search instantly. Never lose track of a route you were watching.',
  },
  {
    id: 'benefit-004',
    icon: 'ClockIcon',
    title: 'Trip History',
    description: 'See every deal you clicked, every trip you explored — all in one timeline.',
  },
];

const stats = [
  { id: 'stat-001', value: '1,200+', label: 'Travel partners' },
  { id: 'stat-002', value: '500M+', label: 'Prices checked daily' },
  { id: 'stat-003', value: '$0', label: 'Booking fees — ever' },
];

export default function AuthBenefitsPanel() {
  return (
    <div className="w-full hero-gradient flex flex-col justify-between p-10 xl:p-14 relative overflow-hidden">
      {/* Background decoration */}
      <div className="absolute top-0 right-0 w-64 h-64 rounded-full bg-white/5 blur-3xl pointer-events-none" />
      <div className="absolute bottom-20 left-0 w-48 h-48 rounded-full bg-accent/20 blur-2xl pointer-events-none" />

      {/* Logo */}
      <div className="relative z-10">
        <div className="flex items-center gap-2.5 mb-3">
          <AppLogo size={40} />
          <span className="font-extrabold text-2xl text-white">TravelHub</span>
        </div>
        <p className="text-white/70 text-sm">
          The world's smartest travel comparison engine
        </p>
      </div>

      {/* Benefits */}
      <div className="relative z-10 my-10 space-y-6">
        <h2 className="text-xl font-700 text-white mb-6">
          Your free account unlocks:
        </h2>
        {benefits.map((benefit) => (
          <div key={benefit.id} className="flex items-start gap-4">
            <div className="w-10 h-10 rounded-xl bg-white/15 flex items-center justify-center flex-shrink-0">
              <Icon name={benefit.icon as any} size={20} className="text-white" />
            </div>
            <div>
              <p className="text-sm font-700 text-white">{benefit.title}</p>
              <p className="text-sm text-white/65 mt-0.5 leading-snug">{benefit.description}</p>
            </div>
          </div>
        ))}
      </div>

      {/* Stats */}
      <div className="relative z-10 border-t border-white/20 pt-6">
        <div className="grid grid-cols-3 gap-4">
          {stats.map((stat) => (
            <div key={stat.id} className="text-center">
              <p className="text-xl font-800 text-white tabular-nums">{stat.value}</p>
              <p className="text-xs text-white/60 mt-0.5">{stat.label}</p>
            </div>
          ))}
        </div>
        <p className="text-xs text-white/40 text-center mt-4">
          Trusted by 12M+ travelers worldwide
        </p>
      </div>
    </div>
  );
}